
export class UserAddressType {
    constructor(
        public isPrimaryAddress: boolean = true,
        public country: number = null,
        public state: string = '',
        public city: string = '',
        public address: string = '',
        public postalCode: string = '',
        public user: number = undefined,
    ) {
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/UserAddressType.ts